import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onMousemove"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "a",
    d: "M0 0h24v24H0V0z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("clipPath", { id: "b" }, [
  /*#__PURE__*/_createElementVNode("use", {
    "xlink:href": "#a",
    overflow: "visible"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "clip-path": "url(#b)",
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["textContent"]

export function render(_ctx, _cache) {
  const _component_icon = _resolveComponent("icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "rating",
    onMouseleave: _cache[1] || (_cache[1] = (...args) => (_ctx.mouseLeave && _ctx.mouseLeave(...args)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fillLevel, (val, i) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "rating-item",
        onMousemove: $event => (_ctx.mouseMove(i)),
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.selected && _ctx.selected(...args)))
      }, [
        (val === 0)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 0,
              class: "rating__empty-star",
              type: "star",
              size: _ctx.size
            }, null, 8, ["size"]))
          : (val < 51)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 1,
                class: _normalizeClass(["icon rating__half-star", { [`icon--${_ctx.size}`]: _ctx.size }]),
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24"
              }, _hoisted_5, 2))
            : (_openBlock(), _createBlock(_component_icon, {
                key: 2,
                class: _normalizeClass(["rating__full-star", {'rating__full-star--hovered': _ctx.hoveredRating}]),
                type: "star",
                size: _ctx.size
              }, null, 8, ["size", "class"]))
      ], 40, _hoisted_1))
    }), 256)),
    _createElementVNode("span", {
      class: "rating__count",
      textContent: _toDisplayString(_ctx.formattedRating)
    }, null, 8, _hoisted_6)
  ], 32))
}